import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Lock, Globe, FileCheck, CheckCircle2, Clock } from 'lucide-react';

const BADGES = [
  { id: 'soc2', label: 'SOC 2 Type II', icon: Shield, status: 'in-progress' },
  { id: 'gdpr', label: 'GDPR Compliant', icon: Globe, status: 'active' },
  { id: 'ccpa', label: 'CCPA Compliant', icon: FileCheck, status: 'active' },
  { id: 'encryption', label: 'AES-256 Encryption', icon: Lock, status: 'active' },
  { id: 'dpa', label: 'DPA Available', icon: FileCheck, status: 'active' },
];

const STATUS_CONFIG = {
  active: {
    dotColor: '#22C55E',
    label: 'Active',
    icon: CheckCircle2,
  },
  'in-progress': {
    dotColor: '#F2A900',
    label: 'In Progress',
    icon: Clock,
  },
};

export default function TrustBadges({
  badges = BADGES,
  variant = 'row',
  linkToSecurity = true,
  className = '',
}) {
  const Wrapper = linkToSecurity ? Link : 'div';
  const wrapperProps = linkToSecurity ? { to: '/security' } : {};

  if (variant === 'compact') {
    return (
      <Wrapper
        {...wrapperProps}
        className={`inline-flex items-center gap-3 px-4 py-2 border border-[rgba(245,241,232,0.08)] hover:border-[#FF4D00]/30 transition-all group ${className}`}
      >
        <Shield className="w-4 h-4 text-[#FF4D00]" />
        <span className="text-xs font-mono text-[rgba(245,241,232,0.72)] tracking-wider uppercase">
          Enterprise Security
        </span>
        {linkToSecurity && (
          <span className="text-xs text-[#FF4D00] opacity-0 group-hover:opacity-100 transition-opacity">→</span>
        )}
      </Wrapper>
    );
  }

  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {badges.map((badge) => {
        const status = STATUS_CONFIG[badge.status] || STATUS_CONFIG.active;
        return (
          <Wrapper
            key={badge.id}
            {...wrapperProps}
            className="group flex items-center gap-2.5 px-4 py-2.5 bg-[#1E1E1E] border border-[rgba(245,241,232,0.08)] hover:border-[#FF4D00]/30 transition-all"
          >
            <badge.icon className="w-4 h-4 text-[rgba(245,241,232,0.72)] group-hover:text-[#FF4D00] transition-colors" />
            <div className="flex flex-col">
              <span className="text-xs font-mono text-[#F5F1E8] tracking-wider leading-none">
                {badge.label}
              </span>
              <div className="flex items-center gap-1 mt-0.5">
                <div
                  className="w-1.5 h-1.5 rounded-full"
                  style={{ backgroundColor: status.dotColor }}
                />
                <span className="text-[10px] font-mono text-[rgba(245,241,232,0.48)] tracking-wider uppercase">
                  {status.label}
                </span>
              </div>
            </div>
          </Wrapper>
        );
      })}
    </div>
  );
}

export { BADGES, STATUS_CONFIG };
